import {
  Box,
  Caption2,
  Color,
  FontFamily,
  JustifyContent,
  AlignItems,
} from '@gousto-internal/citrus-react';

type DietaryInfoProps = {
  children: string;
  label: string;
};

export const DietaryInfoTestId = 'dietary-info';

export function DietaryInfo(props: DietaryInfoProps) {
  const { children, label } = props;

  return (
    <Box
      role="status"
      bg={Color.ColdGrey_800}
      style={{ borderRadius: '50%', aspectRatio: 1 }}
      display="flex"
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      paddingH={1}
      paddingV={1}
      width="25px"
      data-testid={DietaryInfoTestId}
    >
      <Caption2 size={0} fontFamily={FontFamily.ExtraBold} color={Color.White} aria-label={label}>
        {children}
      </Caption2>
    </Box>
  );
}
